import React, { useState, forwardRef } from "react";
import MonthPreview from "./MonthPreview";
import darkLogo from "../../assets/DarkMode.png";
import lightLogo from "../../assets/LightMode.png";

const MobileMonthPreview = forwardRef(({ onDateSelect, selectedDate }, ref) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleDateSelect = (date) => {
		if (onDateSelect) {
			onDateSelect(date);
		}
		setIsOpen(false);
	};

	return (
		<div className="relative lg:hidden">
			{/* Logo/Button */}
			<button
				onClick={() => setIsOpen(!isOpen)}
				className="flex items-center transition-colors"
				aria-label="Toggle calendar"
			>
				<img
					src={darkLogo}
					alt="MyCron Logo"
					className="h-6 w-auto hidden dark:block" // Smaller only in mobile
				/>
				<img
					src={lightLogo}
					alt="MyCron Logo"
					className="h-6 w-auto block dark:hidden" // Smaller only in mobile
				/>
			</button>

			{/* Dropdown Container */}
			<div
				className={`
          fixed inset-0 z-40 lg:hidden
          transition-opacity duration-200
          ${
						isOpen
							? "opacity-100 pointer-events-auto"
							: "opacity-0 pointer-events-none"
					}
        `}
			>
				{/* Backdrop */}
				<div
					className="absolute inset-0 bg-black/20 dark:bg-black/40"
					onClick={() => setIsOpen(false)}
				/>

				{/* Calendar Panel */}
				<div
					className={`
            absolute top-[64px] left-0 right-0 mx-4
            bg-white dark:bg-gray-800 rounded-lg shadow-lg
            transform transition-all duration-200
            ${isOpen ? "translate-y-0" : "-translate-y-4"}
          `}
				>
					<MonthPreview
						ref={ref}
						onDateSelect={handleDateSelect}
						selectedDate={selectedDate}
					/>
				</div>
			</div>
		</div>
	);
});

export default MobileMonthPreview;
